// extracted by mini-css-extract-plugin
module.exports = {"thumbs-gallery":"_9e1425b4d3--thumbs-gallery--H6iYe","slide":"_9e1425b4d3--slide--Hx8ar","is-active":"_9e1425b4d3--is-active--qF2Vm"};